import React from "react";
import "./consultant.scss";
import Img from "../../assets/Group 171.svg";
import { IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
const Consultant = () => {
  return (
    <div className="container bookConsult">
      <div className="bookConsult-image">
        <img className="my-5 pt-5" src={Img} alt="Book Consultation" />
      </div>

      <div className="row row-cols-2 my-5 bookConsultant-form d-flex justify-content-between">
        <div className="col-lg-5 col-md-6 col-sm-12 py-3 bookConsult-content">
          <div className="row row-cols-2 my-4 mail align-items-center">
            {/* <img className="px-0" alt="email icon" /> */}
            <div className="d-flex align-items-center" style={{ flexShrink: '0' }}>
              <IoIosMail style={{ fontSize: '20px' }} />
              <p className="my-0 px-0 text-center">md@varrenyam.com</p>
            </div>
          </div>
          <div className="row row-cols-2 my-4 mail align-items-center">
            {/* <img className="px-0" alt="phone icon" /> */}
            <div className="d-flex align-items-center">
              <FaPhoneAlt style={{ fontSize: '20px' }} />
              <p className="my-0 px-0 text-center">+91 9958302198</p>
            </div>
          </div>
          <div className="row row-cols-2 my-4 mail align-items-center">
            {/* <img className="px-0" alt="email icon" /> */}
            <div className="d-flex align-items-center">
              <IoIosMail style={{ fontSize: '20px' }} />
              <p className="my-0 px-0 text-center">khandelwal@varrenyam.net.in</p>
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 book">
          <form>
            <div className="row row-cols-2 mb-3 align-items-center book-consult-form">
              <input
                type="text"
                className="form-control border-0 border-bottom"
                name="name"
                placeholder="Name"
              />
              <input
                type="email"
                className="form-control border-0 border-bottom"
                name="email"
                placeholder="Email"
              />
              <input
                type="text"
                className="form-control border-0 border-bottom my-3"
                name="subject"
                placeholder="Subject"
              />
              <input
                type="text"
                className="form-control border-0 border-bottom my-3"
                name="phone"
                placeholder="Phone"
              />
            </div>

            <div className="mb-3">
              <label htmlFor="interestedIn" className="form-label text-dark">
                Hello I am Interested in..
              </label>
              <textarea
                name="interestedIn"
                className="form-control border-0 border-bottom my-3"
                rows="3"
                id="interestedIn"
              ></textarea>
            </div>

            <div style={{ float: "right" }}>
              <button
                type="submit"
                className="btn btn-primary d-flex flex-row-reverse"
              >
                <a
                  href="mailto:rajbansal999.rb@gmail.com?subject=&body=name:%0Aemail:%0Aphone:%0Abody:"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Connect Now
                </a>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Consultant;
